import React from 'react';
import { Box, Typography } from '@mui/material';
import { PinDrop, AssignmentInd, Psychology, WorkOutlineOutlined } from '@mui/icons-material';
import { useCandidatsOffre } from './hooks/useCandidatsOffre';
import CandidatsPanel from './components/CandidatsPanel';
import CandidatDetail from './components/CandidatDetail';

const panelSx = { display: 'flex', flexDirection: 'column', minHeight: 0, borderRadius: '14px', background: '#fff', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(15,23,42,0.05)', overflow: 'hidden' };

const CandidatsOffre = () => {
    const state = useCandidatsOffre();
    const { candidats, selectedCandidat, selectedMission, jobUuid } = state;

    return (
        <Box sx={{ p: { xs: 1.5, md: 2.5 }, height: 'calc(100vh - 90px)', display: 'flex', flexDirection: 'column', gap: 2, overflow: 'hidden' }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                    <Box sx={{ width: 38, height: 38, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ebf4fb', color: '#03407b' }}>
                        <AssignmentInd />
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Rattacher des candidats à une offre</Typography>
                        <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>L'IA classe les candidats du vivier selon leur adéquation avec la mission</Typography>
                    </Box>
                </Box>

                {selectedMission && (
                    <Box sx={{ ml: { md: 'auto' }, display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.75, borderRadius: '10px', background: '#f0f7fd', border: '1px solid #aed6f1', maxWidth: 420 }}>
                        <PinDrop sx={{ fontSize: 18, color: '#03407b' }} />
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#03407b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {selectedMission.value}
                            </Typography>
                            {selectedMission.nom_societe && (
                                <Typography sx={{ fontSize: '0.72rem', color: '#64748b' }}>{selectedMission.nom_societe}</Typography>
                            )}
                        </Box>
                        {candidats.length > 0 && (
                            <Box sx={{ ml: 1, px: 1, py: 0.25, borderRadius: '999px', background: '#03407b', color: '#fff', fontSize: '0.72rem', fontWeight: 700, whiteSpace: 'nowrap' }}>
                                {candidats.length} candidat{candidats.length > 1 ? 's' : ''}
                            </Box>
                        )}
                    </Box>
                )}
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: 'minmax(420px, 5fr) 7fr' }, gap: 2, flex: 1, minHeight: 0 }}>
                <Box sx={panelSx}>
                    <CandidatsPanel state={state} />
                </Box>

                <Box sx={panelSx}>
                    {selectedCandidat ? (
                        <CandidatDetail candidat={selectedCandidat} jobUuid={jobUuid} selectedMission={selectedMission} />
                    ) : (
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 4, textAlign: 'center', gap: 1 }}>
                            <Box sx={{ width: 72, height: 72, borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f7fd', color: '#7fb3d3', mb: 1 }}>
                                {candidats.length > 0 ? <Psychology sx={{ fontSize: 38 }} /> : <WorkOutlineOutlined sx={{ fontSize: 36 }} />}
                            </Box>
                            <Typography sx={{ fontSize: '0.98rem', fontWeight: 700, color: '#334155' }}>
                                {candidats.length > 0 ? 'Sélectionnez un candidat' : 'Le profil du candidat apparaîtra ici'}
                            </Typography>
                            <Typography sx={{ fontSize: '0.85rem', color: '#94a3b8', maxWidth: 360 }}>
                                {candidats.length > 0
                                    ? 'Cliquez sur un candidat de la liste pour voir son profil complet, ses scores détaillés et préparer l\'entretien.'
                                    : 'Choisissez une mission puis lancez la recherche pour obtenir le classement des candidats.'}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default CandidatsOffre;
